import React, { Component } from 'react';
import './LogoButton.css'



class LogoButton extends Component {
    // constructor(props){
    //     super(props)
    // }

    getLogoBackgroundClassName=()=>{
        let className = "LogoBackground"
        if(this.props.IntroListShowOrHide)
        {
            className = "LogoBackground On" 
        }
        return className
    }

    render(){
        
        return(
            <div className="LogoButton">
               
               <div className={this.getLogoBackgroundClassName()} >
               </div>
            </div>
        )
    }
}

export default LogoButton
